// extracted by mini-css-extract-plugin
export default {"container":"CompletenessNotifications_container__UiyeN"};